if (!customElements.get('collapse-content')) {
  class CollapseContent extends HTMLElement {
    constructor() {
      super();
      this.initCl();
    }

    initCl() {
      this.collapseInput = this.querySelector('input');
      this.collapseLabel = this.querySelector('label');
      this.collapseExpand = this.querySelector('.collapse-content__answer');
      this.collapseEvent();
    }

    collapseEvent() {
      this.collapseInput.addEventListener('input', () => {
        if (this.collapseInput.checked) {
          this.collapseExpand.classList.add('active');
          this.collapseExpand.style.maxHeight = this.collapseExpand.scrollHeight + 'px';
        } else {
          this.collapseExpand.classList.remove('active');
          this.collapseExpand.style.maxHeight = null;
        }
      });
    }
  }
  customElements.define('collapse-content', CollapseContent);
}
